import { useEffect } from "react";
import { logTopicContentLinkClicked } from "../util/analytics";

let isRegistered = false;

export default function useContentLinks(slugPubType, pageTitle, recordAn) {
  useEffect(() => {
    const handleClick = (event) => {
      const link = event.target.closest("a");

      if (link && link.dataset["location"] === "external") {
        logTopicContentLinkClicked({
          pubType: slugPubType,
          title: pageTitle,
          recordAn,
          isExternal: true,
          linkText: link.textContent.trim(),
          linkUrl: link.href,
        });
      }
    };

    if (!isRegistered) {
      isRegistered = true;
      document.addEventListener("click", handleClick);
    }

    return () => {
      isRegistered = false;
      document.removeEventListener("click", handleClick);
    };
  }, [pageTitle, slugPubType, recordAn]);
}
